<template>
	<nuxt-link
		:id="blok.uuid"
		:to="`/${blok.full_slug}`"
		:aria-label="blok.content.title"
		class="group flex flex-col"
	>
		<nuxt-picture
			v-if="blok.content.image?.filename"
			:src="blok.content.image.filename"
			class="w-full"
			provider="storyblok"
			:alt="blok.content.image?.alt ?? blok.content.title"
			:width="372"
			:height="372"
			sizes="xs:50vw sm:312px md:376px lg:244px xl:308px 2xl:372px"
			:img-attrs="{
				class: 'aspect-square w-full rounded object-cover',
			}"
		/>

		<p class="mt-2 font-sans-caption font-bold group-hover:underline">
			{{ blok.content.title }}
		</p>

		<p
			v-if="blok.content.short_description.length > 0"
			class="line-clamp-4 text-gray-500"
		>
			{{ blok.content.short_description }}
		</p>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

defineProps<{
	blok: ISbStoryData;
}>();
</script>
